import { combineReducers } from "redux";
import { all } from "redux-saga/effects";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { DayEntrySlice } from "../app/modules/tank-sounding/DayEntry/_redux/dayEntrySlice"; //" DayEntry/_redux/dayEntrySlice";// "../app/modules/DayEntry/_redux/dayEntrySlice";
import { InventorySummarySlice } from "../app/modules/tank-sounding/InventorySummary/_redux/reports.Slice";
// import { LogisticsSlice } from "../app/modules/Logistics/_redux/logisticsSlice";
// import { MaintenanceSlice } from "../app/modules/Maintenance/_redux/maintenanceSlice";
import { MovementsSlice } from "../app/modules/tank-sounding/Movements/_redux/movementsSlice";
import { PMSSlice } from "../app/modules/tank-sounding/PMS/_redux/pmsSlice";
import { PWSSlice } from "../app/modules/tank-sounding/PWSDialog/_redux/PWSSlice";
import { ReportsSlice } from "../app/modules/tank-sounding/Reports/_redux/reports.Slice";
import { TanksFarmSlice } from "../app/modules/tank-sounding/Tanks/_redux/tanksSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  dayentry: DayEntrySlice.reducer,
  // sg: SGSlice.reducer,
  movements: MovementsSlice.reducer,
  reports: ReportsSlice.reducer,
  // heights: HeightsSlice.reducer,
  // fractional: FracSlice.reducer, 
  tanksfarm: TanksFarmSlice.reducer,
  // maintenance: MaintenanceSlice.reducer,
  inventorysummary: InventorySummarySlice.reducer,
  pws: PWSSlice.reducer,
  pms: PMSSlice.reducer,
  // dayentry: DayEntrySlice.reducer,
  // sg: SGSlice.reducer,
  // movements: MovementsSlice.reducer,
  // reports: ReportsSlice.reducer,
  // heights: HeightsSlice.reducer,
  // fractional: FracSlice.reducer,
  // tanksfarm: TanksFarmSlice.reducer,
  // maintenance: MaintenanceSlice.reducer,
  // inventorysummary: InventorySummarySlice.reducer,
  // pws: PWSSlice.reducer,
  // pms: PMSSlice.reducer,
  // dashboard: DashboardSlice.reducer,
  // changepassword: ChangePasswordSlice.reducer,
  // logistics: LogisticsSlice.reducer,
  // usermaintenance: UserMaintenanceSlice.reducer,

  // customers: customersSlice.reducer,
  // products: productsSlice.reducer,
  // remarks: remarksSlice.reducer,
  // specifications: specificationsSlice.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
